module.exports = __webpack_public_path__ + "img/instadrive-logo.3e995578.png";